let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import i18n from "../../utils/i18n";
import BillPayService from "../../service/BillPayService.js";

let NotificationCenterLi = require("../../templates/pos/comp/NotificationCenterLi.handlebars");
let moment = require("moment");


let main = function () {
    return Backbone.View.extend({
        el: "#notification",
        bookingManageURL: "/bookingManage",
        initialize: function (options) {
            var self = this;
            self.initNoticeView();
        },
        events: {
            "click li": "chooseNotice",
            "click .selected-all": "selectedAll",
            "click .drop-action": "toggleMark",
            "click .mark-dropdown div": "markStatus",
            "click .palette .delete-message": "deleteNotice",
            "click .notification-container": "_toggleCenter"
        },
        _toggleCenter: function () {
            var notification = $("#notification");
            var center = $(".notification-center");
            if (notification.hasClass('hidden')) {
                notification.removeClass("hidden");
                center.slideToggle(100);
                //center.animate({top: '100px'},"fast");
                this.initNoticeView();
            } else {
                center.slideToggle(100, function () {
                    notification.addClass("hidden");
                });

            }
        },
        changeNoticeStatus: function (img, status) {
            if (status == "checked") {
                img.prop("src", require("../../images/notifications/checked.png"));
                img.addClass("checked");
            } else {
                img.prop("src", require("../../images/notifications/uncheck.png"));
                img.removeClass("checked");
            }
        },
        changeNoticeMark: function (status) {
            var self = this, notices = [];
            _.each($(".notification-ul .notice .checked"), function (checked) {
                var notice = $(checked).closest(".notice");
                $(notice).removeClass().addClass("notice").addClass(status);
                var noticeLi = self.collection.find({id: $(notice).data("id")});
                noticeLi.set({status: status});
                self.changeNoticeStatus($(checked), "checked");
                notices.push(noticeLi.toJSON());
            });
            self.connectNotice(notices, "update");
        },
        deleteNotice: function (evt) {
            var self = this, notices = [];
            if (confirm(i18n.msg("pos.settings.memberCardScheme.alert.deleteScheme.confirm"))) {
                _.each($(".notification-ul .notice .checked"), function (checked) {
                    var notice = $(checked).closest(".notice");
                    self.collection.remove({id: notice.data("id")});
                    notice.fadeOut(500);
                    console.log("delete notice for " + notice.data("id"));
                    notices.push({id: notice.data("id")});
                });
                this.connectNotice(notices, "delete");
            }
            return false;
        },
        toggleMark: function () {
            $(".mark-dropdown").toggleClass("hidden");
            return false;
        },
        markStatus: function (evt) {
            this.changeNoticeMark($(evt.currentTarget).data("status"));
            $(".selected-all").prop("src", require("../../images/notifications/uncheck.png")).removeClass("checked");
            this.toggleMark();
        },
        selectedAll: function (evt) {
            var img = $(evt.currentTarget), self = this;
            if (img.hasClass("checked")) {
                img.prop("src", require("../../images/notifications/uncheck.png"));
                img.removeClass("checked");
                _.each($(".notification-ul .noticeStatus"), function (notice) {
                    self.changeNoticeStatus($(notice));
                });
            } else {
                img.prop("src", require("../../images/notifications/checked.png"));
                img.addClass("checked");
                _.each($(".notification-ul .noticeStatus"), function (notice) {
                    self.changeNoticeStatus($(notice), "checked");
                });
            }
            return false;
        },
        chooseNotice: function (evt) {
            var li = $(evt.currentTarget);
            console.log("change notice for " + li);
            li.removeClass("Unread").addClass("Read");
            var img = li.find(".noticeStatus");
            var notice = this.collection.find({id: li.data("id")});
            if (img.hasClass("checked")) {
                this.changeNoticeStatus(img);
            } else {
                this.changeNoticeStatus(img, "checked");
            }
            notice.set({status: "Read"});
            this.connectNotice([notice.toJSON()], "update");
            if (li.data("bookinglink")) {
                window.open(li.data("bookinglink"));
                return;
            }
            return false;
        },
        connectNotice: function (notice, type) {
            var jxhr, self = this, url = type == "update" ? "/pos/updateNotice" : "/pos/deleteNotice";
            var params = [];
            _.each(notice, function (noti) {
                params.push({
                    id: noti.id,
                    status: noti.status
                })
            });
            jxhr = $.post(url, {notices: JSON.stringify(params)});
            jxhr.done(function (response) {
                if (response.success) {
                    self.statisticalUnread(self.collection.where({status: "Unread"}).length);
                }
            });
            jxhr.fail(function (response) {

            });

        },
        statisticalUnread: function (count) {
            var notiIcon = $(".notification-status");
            if (count > 0) {
                notiIcon.removeClass("v5hidden");
                $(".notification-icon .badge").text(count).css('display', 'block');
                $(".nav.head .badge").text(count).css('display', 'block');
            } else {
                notiIcon.addClass("v5hidden");
                $(".notification-icon .badge").text(0).css('display', 'none');
                $(".nav.head .badge").text(0).css('display', 'none');
            }
        },
        receiveNotice: function (notification) {
            console.log("receiveNotice ----" + notification);
            var bill = notification.get("bill");
            if (bill && bill.transaction) {
                console.log("bill weixinTransaction", bill.transaction);
                if (bill.transaction.totalRefund > 0) {
                    BillPayService.refundPaid(notification);
                } else {
                    BillPayService.paidSuccess(notification);
                }
            }
            this.initNoticeView();
        },
        initNoticeView: function () {
            var self = this;
            console.log(this.collection);
            $(".notification-center .no-message").addClass("hidden");
            if (this.collection.size() > 0) {
                $(".notification-center ul").empty();
                _.each(this.collection.models, function (notification) {
                    var params = notification.toJSON();
                    params.unread = params.status == "Unread";
                    params.time = moment(notification.get('dateCreated')).fromNow();
                    params.type = params.className;
                    params.typeName = i18n.msg("pos.notification.name." + params.type);
                    if (!params.type) {
                        params.type = "system";
                        params.typeName = i18n.msg("pos.notification.name." + params.type);
                    }
                    if (params.type == "booking") {
                        params.link = self.bookingManageURL + "?filterDate=" + moment(params.bookingStartDate).format("YYYY-MM-DD");
                    }
                    $(".notification-center ul").append(NotificationCenterLi(params));
                });
            } else {
                $(".notification-center .no-message").removeClass("hidden");
            }
            this.statisticalUnread(this.collection.where({status: "Unread"}).length);
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/NotificationView.js